import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges class names, with later Tailwind utilities beating earlier conflicting ones.
 * Without the merge step a component's `className` prop cannot override its own
 * defaults, which turns every variant into a prop.
 *
 * ── A TRAP WORTH KNOWING ABOUT ───────────────────────────────────────────────
 * Never write a font size as `text-[16px]` or `text-[var(--pv-text-sm)]` in a string
 * that also carries a text colour. tailwind-merge cannot tell an arbitrary `text-[…]`
 * size from an arbitrary `text-[…]` colour — both are the same conflict group — so it
 * keeps whichever comes last and silently discards the other.
 *
 * That is not theoretical: it removed `text-[var(--pv-brand-on)]` from every primary
 * button, producing dark text on a dark ground with no error anywhere.
 *
 * Write font sizes as an arbitrary PROPERTY instead — `[font-size:var(--pv-text-sm)]` —
 * which gets its own group and cannot collide with a colour.
 * ─────────────────────────────────────────────────────────────────────────────
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
